import React from 'react';
import {
  BRAND, BRAND_SOFT, BRAND_DARK,
  BG_CARD, BORDER, TEXT_INK, TEXT_SECONDARY, TEXT_TERTIARY,
} from '../styles';

interface Props {
  selected: boolean;
  onClick: () => void;
  title: string;
  body: string;
}

export default function SelfSetupCard({ selected, onClick, title, body }: Props) {
  return (
    <div
      onClick={onClick}
      style={{
        border: '1.5px solid ' + (selected ? BRAND : BORDER),
        background: selected ? BRAND_SOFT : BG_CARD,
        borderRadius: 10, padding: '14px 16px', cursor: 'pointer',
        display: 'flex', alignItems: 'flex-start', gap: 12,
      }}
    >
      <span style={{
        width: 18, height: 18, borderRadius: '50%',
        border: '1.6px solid ' + (selected ? BRAND : TEXT_TERTIARY),
        display: 'grid', placeItems: 'center', flexShrink: 0, marginTop: 2,
      }}>
        {selected && <span style={{ width: 9, height: 9, borderRadius: '50%', background: BRAND }} />}
      </span>
      <div>
        <div style={{
          fontSize: 14, fontWeight: 700,
          color: selected ? BRAND_DARK : TEXT_INK, marginBottom: 2,
        }}>{title}</div>
        <div style={{ fontSize: 13, color: TEXT_SECONDARY, lineHeight: 1.5 }}>{body}</div>
      </div>
    </div>
  );
}